import { useModalData } from "@circle-react-shared/uikit/ModalV2";
import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import type { ReactNode } from "react";

import { ModalCloseButton } from "../ModalCloseButton";
import { LeftContainer } from "./LeftContainer";
import { NavContainer } from "./NavContainer";
import { NavGroup } from "./NavGroup";
import { NavItem } from "./NavItem";
import type { NavItemProps } from "./NavItem";
import { RightContainer } from "./RightContainer";
import { TitleItem } from "./TitleItem";

interface RootProps {
  items?: NavItemProps[];
  rightNode?: ReactNode;
  title?: string;
  titleNode?: ReactNode;
}

export const Root = ({
  titleNode,
  title,
  items = [],
  rightNode,
}: RootProps) => {
  const isSmScreen = useSmScreenMediaQuery();
  const { onClose, shouldShowCloseButton } = useModalData();

  return (
    <NavContainer>
      <LeftContainer>
        <TitleItem title={title}>{titleNode}</TitleItem>
        {shouldShowCloseButton && isSmScreen && (
          <ModalCloseButton onClick={onClose} />
        )}
      </LeftContainer>

      <NavGroup>
        {items.map(item => (
          <NavItem {...item} key={item.label} />
        ))}
      </NavGroup>

      {rightNode && <RightContainer>{rightNode}</RightContainer>}
    </NavContainer>
  );
};
